/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Detail_Collection_EyebrowInputs */

const en_directory_taxonomy_detail_collection_eyebrow = /** @type {(inputs: Directory_Taxonomy_Detail_Collection_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curated collection`)
};

const zh_directory_taxonomy_detail_collection_eyebrow = /** @type {(inputs: Directory_Taxonomy_Detail_Collection_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选合集`)
};

/**
* | output |
* | --- |
* | "Curated collection" |
*
* @param {Directory_Taxonomy_Detail_Collection_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_detail_collection_eyebrow = /** @type {((inputs?: Directory_Taxonomy_Detail_Collection_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Detail_Collection_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_detail_collection_eyebrow(inputs)
	return zh_directory_taxonomy_detail_collection_eyebrow(inputs)
});
export { directory_taxonomy_detail_collection_eyebrow as "directory.taxonomy_detail.collection.eyebrow" }